import { FC } from 'react';
import { State } from 'redux/initialState';
import { useTranslate } from 'hooks/useTranslate';
import { useSelector } from 'react-redux';

import { SharesTitle } from 'types';

import NoItemsAvailable from 'modules/_shared/components/EmptyStates/NoItemsAvailable';
import SharesTitlesTableRow from './SharesTitlesTableRow';

import { useGetSocietySharesTitleDocument } from '../hooks/useGetSocietySharesTitleDocument';

type Props = {
  sharesTitles: SharesTitle[];
};

const SharesTitleTableBody: FC<Props> = ({ sharesTitles }) => {
  const { t } = useTranslate();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { document: societySharesTitleDocument } =
    useGetSocietySharesTitleDocument({ society: actualSociety }).data;

  const hasData = sharesTitles?.length > 0;

  return (
    <>
      <tbody>
        {hasData ? (
          sharesTitles
            ?.sort((a: SharesTitle, b: SharesTitle) => b.number - a.number)
            ?.map((sharesTitle: SharesTitle, index: number) => (
              <tr className="nk-tb-item" key={`title-row-${sharesTitle?._id}`}>
                <SharesTitlesTableRow
                  index={index}
                  title={sharesTitle}
                  societySharesTitleDocument={societySharesTitleDocument}
                />
              </tr>
            ))
        ) : (
          <NoItemsAvailable mainMessage={t('NoTitlesMessage')} />
        )}
      </tbody>
    </>
  );
};

export default SharesTitleTableBody;
